import { useEffect, useState } from 'react';
import type { PreviewEventDetail } from '../adapters/printers/preview.js';
import { usePageActivity } from '../hooks/usePageActivity.js';

interface PrinterPreview {
  png: string;
  copies: number;
  templateName: string;
  widthMm: number;
  heightMm: number;
}

/** Only the visible Ionic page owns the global printer preview event. */
export function usePrinterPreview(pathname: string) {
  const { isActive, capture } = usePageActivity(pathname);
  const [preview, setPreview] = useState<PrinterPreview | null>(null);
  useEffect(() => {
    if (!isActive) {
      setPreview(null);
      return;
    }
    const isCurrentVisit = capture();
    const onPreview = (event: Event): void => {
      const detail = (event as CustomEvent<PreviewEventDetail>).detail;
      if (!isCurrentVisit() || !detail?.png || detail.handled) return;
      detail.handled = true;
      setPreview({
        png: detail.png,
        copies: detail.copies,
        templateName: detail.template.name,
        widthMm: detail.template.width_mm,
        heightMm: detail.template.height_mm,
      });
    };
    window.addEventListener('trackeat:preview', onPreview);
    return () => window.removeEventListener('trackeat:preview', onPreview);
  }, [capture, isActive]);
  return [isActive ? preview : null, setPreview] as const;
}
